import * as Ru from "./ruRU";
import * as En from "./enEN";

export default {
  ru: {
    ...Ru.Auth,
    ...Ru.Services,
    ...Ru.Studies,
    ...Ru.Viewer,
    ...Ru.Langs,
    ...Ru.General,
    ...Ru.Community,
    ...Ru.Edu,
  },
  en: {
    ...En.Auth,
    ...En.Services,
    ...En.Studies,
    ...En.Viewer,
    ...En.Langs,
    ...En.General,
    ...En.Community,
    ...En.Edu,
  },
};
